























































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import QuestionAnswer from "../components/question-answer.vue";
import Results from "../components/results.vue";
import {
  AmountOfStructuredInputData,
  ApplicationsUsed,
  ProcessFrequency,
  ProcessSteps
} from "../store/assessment.calc";
import {
  IAssessment,
  IAssessmentInputs,
  IAssessmentOutputs,
  IQuestionSet
} from "../store/main.interfaces";
import { makeSimpleDigitalAssessmentObject } from "../store/assessment.util";
import assessments from "../store/modules/assessments";
import { getQuestions } from "../store/questions";
import { assembleAssessmentOutputs } from "../store/assessment.assembly";
import AutoCompleteTextField from "../components/autocomplete-text-field.vue";
import { isMobile } from "../utils/device.utils";
import { TranslateResult } from "vue-i18n";

let entries: IAssessment[] = [];

@Component({
  components: { QuestionAnswer, Results, AutoCompleteTextField }
})
export default class QuickAssistant extends Vue {
  editableAssessment: IAssessment = makeSimpleDigitalAssessmentObject();

  @Prop({ default: false })
  isModalMode!: boolean;

  questions: IQuestionSet = getQuestions();

  currentStep = 1;
  noNameAlert: boolean = false;
  failedCreationOrUpdateAlert: boolean = false;
  savedDialog: boolean = false;

  get isMobile() {
    return isMobile();
  }

  async saveAssessment() {
    Object.assign(this.editableAssessment, {
      outputs: this.getCalculatedAssessmentOutputs()
    });
    if (
      this.editableAssessment.name !== undefined &&
      this.editableAssessment.name !== ""
    ) {
      const createdOrUpdatedAssessment = await assessments.createOrUpdateAssessment(
        this.editableAssessment
      );
      if (createdOrUpdatedAssessment.name !== undefined) {
        this.$emit("createdAssessment", createdOrUpdatedAssessment);
        this.savedDialog = true;
      } else {
        this.failedCreationOrUpdateAlert = true;
      }
    } else {
      this.noNameAlert = true;
    }
  }
  onConfirmSave() {
    this.savedDialog = false;
    this.close();
  }
  close() {
    if (this.isModalMode) {
      this.$emit("close", undefined);
    }
  }
  resetData() {
    this.editableAssessment = makeSimpleDigitalAssessmentObject();
    this.questions = getQuestions();
    for (const key in this.questions) {
      const assessmentKey: keyof IAssessmentInputs = key as keyof IAssessmentInputs;
      this.questions[
        assessmentKey
      ].answerValue = this.editableAssessment.inputs[assessmentKey];
    }
    this.currentStep = 1;
  }
  created() {
    this.resetData();
  }
  getCalculatedAssessmentOutputs() {
    this.editableAssessment.inputs.processFrequency = this.processFreqSliderValueToCalculationValue(
      this.processFrequency
    );
    this.editableAssessment.inputs.averageRuntime = this.averageRuntime;
    const assessmentOutputs: IAssessmentOutputs = assembleAssessmentOutputs(
      this.editableAssessment.inputs
    );
    return assessmentOutputs;
  }

  onShortKey({ srcKey }: { srcKey: "esc" | "backspace" | "enter" }) {
    switch (srcKey) {
      case "esc":
      case "backspace":
        if (this.currentStep === 1) {
          this.close();
        }
        this.prevStep();
        break;
      case "enter":
      default:
        this.nextStep();
        break;
    }
  }
  nextStep() {
    if (this.currentStep === 1 && !this.canContinueFromStep1) {
      return;
    }
    this.currentStep++;
    if (this.currentStep === 5) {
      this.saveAssessment();
    }
    this.currentStep = Math.min(this.currentStep, 4);
  }
  prevStep() {
    this.currentStep--;
    this.currentStep = Math.max(this.currentStep, 1);
  }

  canContinueFromStep1: boolean = false;
  updateCanContinueFromStep1() {
    this.canContinueFromStep1 =
      this.editableAssessment &&
      this.editableAssessment.name != null &&
      this.editableAssessment.name != "";
  }

  get availableDepartments() {
    return assessments.allDepartments;
  }

  // Process Frequency
  get processFrequencyLabel() {
    let val = this.processFreqSliderValueToCalculationValue(
      this.processFrequency
    );
    const NUMBER_TO_WORD: { [key: number]: string | TranslateResult } = {
      1: this.$t("numbers.counting.1"),
      2: this.$t("numbers.counting.2"),
      3: this.$t("numbers.counting.3"),
      4: this.$t("numbers.counting.4"),
      5: this.$t("numbers.counting.5"),
      6: this.$t("numbers.counting.6"),
      7: this.$t("numbers.counting.7"),
      8: this.$t("numbers.counting.8"),
      9: this.$t("numbers.counting.9"),
      10: this.$t("numbers.counting.10")
    };
    let label;
    if (val < ProcessFrequency.WEEKLY) {
      const perMonth = Math.ceil(val / ProcessFrequency.MONTHLY);
      label = this.$tc("times.timesMonthly", perMonth);
    } else if (val < ProcessFrequency.DAILY) {
      const perWeek = Math.ceil(val / ProcessFrequency.WEEKLY);
      label = this.$tc("times.timesWeekly", perWeek);
    } else {
      const perDay = Math.ceil(val / ProcessFrequency.DAILY);
      label = this.$tc("times.timesDaily", perDay);
    }
    return label;
  }
  processFrequency = 50;
  get selectedProcessFrequency() {
    return this.processFrequency;
  }
  set selectedProcessFrequency(val: number) {
    this.processFrequency = val;
  }
  processFreqSliderValueToCalculationValue(val: number) {
    let targetVal: number;
    if (val < 20) {
      const MAX_MONTHLY = 3;
      const MIN_MONTHLY = 1;
      const monthlyValue = val / 20;
      val =
        MIN_MONTHLY +
        monthlyValue *
          (MAX_MONTHLY + 1 - MIN_MONTHLY) *
          ProcessFrequency.MONTHLY;
      const perMonth = Math.ceil(val / ProcessFrequency.MONTHLY);
      targetVal = perMonth * ProcessFrequency.MONTHLY;
    } else if (val < 50) {
      const MAX_WEEKLY = 4;
      const MIN_WEEKLY = 1;
      const weeklyValue = (val - 20) / 30;
      val =
        MIN_WEEKLY +
        weeklyValue * (MAX_WEEKLY + 1 - MIN_WEEKLY) * ProcessFrequency.WEEKLY;
      const perWeek = Math.ceil(val / ProcessFrequency.WEEKLY);
      targetVal = perWeek * ProcessFrequency.WEEKLY;
    } else {
      const MAX_DAILY = 10;
      const MIN_DAILY = 1;
      const dailyValue = (val - 50) / 50;
      val =
        MIN_DAILY +
        dailyValue * (MAX_DAILY - MIN_DAILY) * ProcessFrequency.DAILY;
      const perDay = Math.ceil(val / ProcessFrequency.DAILY);
      targetVal = perDay * ProcessFrequency.DAILY;
    }
    return targetVal;
  }

  // Average Runtime
  averageRuntime = 60;
  get selectedAverageRuntime() {
    return this.averageRuntime;
  }
  set selectedAverageRuntime(val: number) {
    this.averageRuntime = this.editableAssessment.inputs.averageRuntime = val;
    if (this.averageRuntime > 85) {
      this.editableAssessment.inputs.amountOfStructuredInputData =
        AmountOfStructuredInputData.FORTY_TO_SIXTY;
      this.editableAssessment.inputs.applicationsUsed =
        ApplicationsUsed.FOUR_TO_FIVE;
      this.editableAssessment.inputs.processSteps =
        ProcessSteps.TWENTYFIVE_TO_FOURTY;
    } else if (this.averageRuntime > 29) {
      this.editableAssessment.inputs.amountOfStructuredInputData =
        AmountOfStructuredInputData.SIXTY_TO_EIGHTY;
      this.editableAssessment.inputs.processSteps =
        ProcessSteps.FIFTEEN_TO_TWENTYFIVE;
      this.editableAssessment.inputs.applicationsUsed =
        ApplicationsUsed.TWO_TO_THREE;
    } else if (this.averageRuntime < 9) {
      this.editableAssessment.inputs.applicationsUsed = ApplicationsUsed.ONE;
      this.editableAssessment.inputs.processSteps = ProcessSteps.TEN_TO_FIFTEEN;
    }
    this.updateHumanError();
  }
  get averageRuntimeDurationLabel() {
    return this.prettifyDuration(this.averageRuntime);
  }
  applySnapAverageRuntime() {
    this.averageRuntime = this.snapAverageRuntime(this.averageRuntime);
    this.editableAssessment.inputs.averageRuntime = this.averageRuntime;
  }
  snapAverageRuntime(inputMinutes: number) {
    let snapFactor = 5;
    if (inputMinutes > 30 && inputMinutes < 90) {
      snapFactor = 15;
    } else if (inputMinutes > 60) {
      snapFactor = 30;
    }
    inputMinutes = Math.round(inputMinutes / snapFactor) * snapFactor;
    inputMinutes = Math.min(inputMinutes, 60 * 6);
    return inputMinutes;
  }
  prettifyDuration(inputMinutes: number) {
    inputMinutes = this.snapAverageRuntime(inputMinutes);
    const hours = Math.floor(inputMinutes / 60);
    const minutes = inputMinutes % 60;
    return hours + ":" + minutes.toFixed(0).padStart(2, "0") + "h";
  }

  // Complexity
  PROCESS_STEPS_ANSWERS = getQuestions().processSteps.answerPossibilities;
  PROCESS_STEPS_LABELS = this.PROCESS_STEPS_ANSWERS.map(p => p.name);
  get selectedProcessSteps() {
    return this.PROCESS_STEPS_ANSWERS.findIndex(
      a => a.value == this.editableAssessment.inputs.processSteps
    );
  }
  updateProcessSteps(val: number) {
    this.editableAssessment.inputs.processSteps = getQuestions().processSteps.answerPossibilities[
      val || 0
    ].value;
    this.updateHumanError();
  }

  updateHumanError() {
    const averageRuntime = this.editableAssessment.inputs.averageRuntime;
    const stepsFactor = this.editableAssessment.inputs.processSteps;
    // a minimum of 5% of all executions contain a human error
    // if the process runs longer than 30 minutes, if will contain more errors
    this.editableAssessment.inputs.humanErrorPercentage = Math.min(
      60,
      Math.max(5, (averageRuntime / 30) * 6 * stepsFactor)
    );
  }
  @Watch("currentStep")
  updatedAssessment(val: number) {
    this.editableAssessment.outputs = this.getCalculatedAssessmentOutputs();
  }
}
